// tenderForm.js
const initialState = () => ({
  loading: false,
  data: {
    tender_id: null,
    offered_price: null, // store as number|null
    paid_participation_fee: null,
    form_data: {},
  },
})

const state = initialState()

const getters = {
  data: (state) => state.data,
  isLoading: (state) => state.loading,
  hasValidPrice: (state) =>
    typeof state.data.offered_price === 'number' &&
    !Number.isNaN(state.data.offered_price) &&
    state.data.offered_price >= 0,
}

function toNumberOrNull(val) {
  if (val === '' || val === undefined || val === null) return null
  const n = Number(val)
  return Number.isFinite(n) ? n : null
}

const mutations = {
  setLoading(state, loading) {
    state.loading = !!loading
  },

  // Replace entire data object, merging with defaults
  setData(state, payload = {}) {
    state.data.tender_id = payload.id ?? payload.tender_id ?? null
    state.data.offered_price = toNumberOrNull(
      payload.offered_price ?? payload.bid_amount,
    )
    state.data.paid_participation_fee = toNumberOrNull(
      payload.paid_participation_fee,
    )
    state.data.form_data = { ...(payload.form_data || {}) }
  },

  mergeData(state, partial = {}) {
    if ('id' in partial || 'tender_id' in partial) {
      state.data.tender_id =
        partial.id ?? partial.tender_id ?? state.data.tender_id
    }
    if ('offered_price' in partial || 'bid_amount' in partial) {
      state.data.offered_price = toNumberOrNull(
        partial.offered_price ?? partial.bid_amount,
      )
    }
    if ('paid_participation_fee' in partial) {
      state.data.paid_participation_fee = toNumberOrNull(
        partial.paid_participation_fee,
      )
    }
    if ('form_data' in partial) {
      state.data.form_data = {
        ...state.data.form_data,
        ...(partial.form_data || {}),
      }
    }
  },

  setTenderId(state, id) {
    state.data.tender_id = id ?? null
  },

  setOfferedPrice(state, price) {
    state.data.offered_price = toNumberOrNull(price)
  },
  setPaidParticipationFee(state, amount) {
    state.data.paid_participation_fee = toNumberOrNull(amount)
  },

  setFormData(state, obj) {
    state.data.form_data = { ...(obj || {}) }
  },

  updateFormData(state, patch) {
    state.data.form_data = { ...state.data.form_data, ...(patch || {}) }
  },

  // Clear only form_data
  clearFormData(state) {
    state.data.form_data = {}
  },

  // Reset whole module to defaults
  reset(state) {
    Object.assign(state, initialState())
  },

  setDataInit(state, data) {
    state.data.tender_id = data?.id ?? data?.tender_id ?? null
    state.data.offered_price = toNumberOrNull(data?.offered_price)
    state.data.paid_participation_fee = toNumberOrNull(
      data?.paid_participation_fee,
    )
  },
  emptyFields(state) {
    state.data.form_data = {}
  },
}

const actions = {
  init({ commit }, payload) {
    commit('setData', payload)
  },
  reset({ commit }) {
    commit('reset')
  },
  applyPrice({ commit }, price) {
    commit('setOfferedPrice', price)
  },
  patchForm({ commit }, patch) {
    commit('updateFormData', patch)
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
